import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@shared/auth/auth.guard';

import { RoleGuardService } from '@app/shared/auth/role-guard.service';
import { UsersComponent } from './pages/users/users.component';
import { PermissionsComponent } from './pages/permissions/permissions.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, RoleGuardService],
    children: [
      { path: '', redirectTo: 'usuarios', pathMatch: 'full' },
      {
        path: 'usuarios',
        component: UsersComponent,
      },
      {
        path: 'permissoes',
        component: PermissionsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccessControlRoutingModule {}
